import generalUpload from "./upload.class";
import {ProgressViewState, UploadStatuses} from "../../../../../../models";
import dayjs from "dayjs";
import sectionUploadsOffice from "./section-uploads-office.class";
import problem from "./section-problem.class";
import {
    BUNDLE_FOLDER,
    getBundleSectionFileName
} from "../../../../../components/client/application-stages/_common/uploads/Bundler";
import minMax from 'dayjs/plugin/minMax'
import {joinWithConjunction} from "../../../../../../assets/scripts/string-functions";

dayjs.extend(minMax)

export default class generalSection {
    // Builds a section wrapper around mortgage uploads, derives display metadata, and initializes status/bundle state.
    constructor(request, mortgage, props, uploadFactory = null) {

        this.request = request
        this.errors = [] // errors on section, upload-steps on uploads
        const {data, name, applicant, index, stage, category, defaultUserStages, ...rest} = props;
        this.mortgage = mortgage;
        this.statementAlignmentDate = mortgage.requirement.statementAlignmentDate ? dayjs(mortgage.requirement.statementAlignmentDate, "YYYY-MM-DD").startOf('day') : null;
        this.uploadFactory = uploadFactory
        this.defaultUserStages = defaultUserStages

        this.props = rest
        this.data = data;
        this.name = name;
        this.category = category;
        this.stage = stage;
        this.index = index;
        this.applicant = applicant;
        this.progress = (() => {
            const found = this.mortgage.progress.filter(item =>
                !item.deleted &&
                item.sectionType === 'UPLOAD' &&
                //item.applicationStage === this.stage &&
                item.sectionName === this.name &&
                (this.index == null ? item.sectionIndex == null : item.sectionIndex === this.index)
            );


            if (found.length) {
                // sort by date
                found.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                return found[0]
            }
            this.errors.push(`No progress found for section ${this.name} with index ${this.index}`)
            return null
        })()
        this.isActive = this.progress?.viewState !== ProgressViewState.HIDDEN
        this.applicantStrings = (this.applicant) ? this.mortgage[`applicant${this.applicant}`].strings : null
        this.title = (() => {
            if (this.data) {

                const number = (this?.data?.accountNumber || this?.data?.iban || '').replace(/\s+/g, '')
                if (number) {
                    // get last 4 digits and add 4 *
                    const last4 = number.slice(-4);

                    if (!last4) {
                        return `${this.props.title}`;
                    }
                    return `${this.props.title}:****${last4}`;
                }
            }

            return this.props.title
        })()


        this.ownerName = (() => {
            if (!this.applicant) {
                return ``;
            }
            if (this.applicant === 1) {
                return `${this.mortgage.applicant1.firstName}`.trim();
            }
            return `${this.mortgage.applicant2.firstName}`.trim();
        })()
        this.personalTitle = (() => {
            if (!this.applicant) {
                return `${this.title}`;
            }
            if (this.category === 'bank-statements' && this.data?.joint) {
                return `Joint ${this.title}`;
            }
            const your = this.mortgage[`applicant${this.applicant}`].strings.your
            return `${your} ${this.title}`;
        })()
        // hack for pre-approved updating bank statement sections
        let uploadsForUse
        if (this.props.isStatement && this.data.updateAtPreApproval && this.name.startsWith('updated-statements')) {
            uploadsForUse = [...mortgage.uploads.filter(item =>
                !item.deleted &&
                item.stage === 'APPLY' &&
                item.section.startsWith('current-accounts') &&
                (index == null ? item.index == null : item.index === index)),
                ...mortgage.uploads.filter(item =>
                    !item.deleted &&
                    item.stage === stage &&
                    item.section === name &&
                    (index == null ? item.index == null : item.index === index)
                )
            ]
        } else {
            uploadsForUse = mortgage.uploads.filter(item =>
                !item.deleted &&
                // item.stage === stage &&
                item.section === name &&
                (index == null ? item.index == null : item.index === index))
        }


        this.uploads = uploadsForUse
            .map(upload => {
                const queries = this.mortgage.queries.filter(query => query.referenceId === upload.id && query.referenceType === 'UPLOAD');
                if (uploadFactory) {
                    const factory = new uploadFactory({
                        ...request,
                        mortgage: this.mortgage
                    }, upload, queries, this.data);
                    //   factory.calcProblems(this)
                    return factory;
                } else {
                    return new generalUpload({...request, mortgage: this.mortgage}, upload, queries);
                }
            })
        this.uploadsOffice = null
        // this.queries = this.mortgage.queries.filter(item => !item._deleted && item.stage === this.stage && item.section === this.name && (this.index == null ? item.index == null : item.index === this.index))

        this.activeUploads = this.uploads.filter(upload => upload.isActive)
        this.verifiableUploads = this.activeUploads.filter(upload => upload.isVerifiable)
        //this.verifiableUploads = this.uploads.filter(upload => !upload.isSupp)
        // do this LAST, so that 'this' can be used in the uploadFactory

        this.adminStatus = (() => {
            if (!this.uploads.length) {
                return {
                    text: 'NO UPLOADS',
                    color: "default"
                };
            }
            if (!this.isActive) {
                return {
                    text: ProgressViewState.HIDDEN,
                    color: "default"
                };
            }
            if (!this.progress) {
                return {
                    text: 'NOT STARTED',
                    color: "default"
                };
            }
            if (this.progress?.viewState === ProgressViewState.COMPLETE) {
                return {
                    text: 'MANUAL COMPLETE',
                    color: "green"
                }
            }
            if (this.progress?.sectionChecked) {
                return {
                    text: 'COMPLETE',
                    color: "green"
                }
            }
            return {
                text: 'ACTIVE',
                color: "geekblue"
            }
        })()
        this.isComplete = this.progress?.viewState === ProgressViewState.COMPLETE || !!this.progress?.sectionChecked;
        this.internalNoteAsString = (() => {
            if (!this.progress?.internalNote || !this.progress?.internalNote.length) {
                return '';
            }
            return this.progress.internalNote.join('\n');
        })()
        this.internalNoteAsArray = (() => {
            if (!this.progress?.internalNote || !this.progress?.internalNote.length) {
                return [];
            }
            return this.progress.internalNote;
        })()
        if (!this.uploadFactory) {
            this.sortByDateProp(null)
        }
        this.bundle = (() => {


            let fileName = getBundleSectionFileName(this)
            const existingBundles = this.mortgage.UserMortgageDocuments.filter(it => it.folder === BUNDLE_FOLDER && it.stage === this.stage && it.fileName === fileName && it.submissionID === this.mortgage?.activeSubmission?.id)
            const existingBundle = existingBundles.length ? existingBundles.sort((a, b) => dayjs(b.createdAt).diff(dayjs(a.createdAt)))[0] : null

            const bundleCreatedAt = existingBundle ? dayjs(existingBundle.createdAt) : null


            let bundleExpired = false
            if (bundleCreatedAt) {
                // are there new active uploads in this section?
                const hasNewUploads = this.activeUploads.some(upload => {
                    const uploadCreatedAt = dayjs(upload.props.upload.createdAt)
                    return bundleCreatedAt.isBefore(uploadCreatedAt);
                })
                bundleExpired = hasNewUploads
            }


            // const fileName = this.getBundleFileName()
            // const existingSectionBundle = mortgage.UserMortgageDocuments.find(it => it.folder === BUNDLE_FOLDER && it.stage === this.stage && it.fileName === fileName)
            // if (existingSectionBundle && !this.uploads.filter(u => u.isActive).length){
            //     return {
            //         outOfSync: true,
            //         bundled: true,
            //         document: existingSectionBundle,
            //     }
            // }

            // const existingSectionBundleDate = existingSectionBundle ? dayjs(existingSectionBundle.createdAt) : null
            // const outOfSync = existingSectionBundleDate ? this.uploads.filter(u => u.isActive).some(upload => dayjs(upload.props.upload.createdAt).isAfter(existingSectionBundleDate)) : null
            return {
                outOfSync: bundleExpired,
                bundled: !!existingBundle,
                document: existingBundle,
            }
        })()
        this.derivedUserStages = this.progress?.userStages ?? this.defaultUserStages ?? [this.stage]
        this.summary = {}
        this.problems = []
        this.useStatementAlignmentDateToExpire = true
    }

    // Stores upload date ranges in chronological order and derives section-level `from/to` summary values.
    setUploadsRanges = (ranges) => {

        this.uploadsRanges = ranges.sort(
            (a, b) => a.start.date.isBefore(b.start.date) ? -1 : a.start.date.isAfter(b.start.date) ? 1 : 0
        ) || [];
        this.summary.range = {}

        if (this.uploadsRanges.length > 0) {
            if (this.uploadsRanges[0].start?.date) { //&& (!this.uploadsRanges[0].start.hasOwnProperty('balance') || this.uploadsRanges[0].start?.balance != null)) {
                this.summary.range.from = this.uploadsRanges[0].start
                this.summary.range.from.uploadId = this.uploadsRanges[0].uploadId;
            }
            if (this.uploadsRanges[0].start?.date) {//} && this.uploadsRanges[0].start?.balance != null) {
                this.summary.range.from = this.uploadsRanges[0].start
                this.summary.range.from.uploadId = this.uploadsRanges[0].uploadId;
            }
            if (this.uploadsRanges[this.uploadsRanges.length - 1].end?.date) {//&& this.uploadsRanges[this.uploadsRanges.length - 1].end?.balance != null) {
                this.summary.range.to = this.uploadsRanges[this.uploadsRanges.length - 1].end
                this.summary.range.to.uploadId = this.uploadsRanges[this.uploadsRanges.length - 1].uploadId;
            }
            if (this.summary.range.from && this.summary.range.to) {
                this.summary.range.ok = true;
                this.summary.balanceDifference = this.summary.range.to.balance - this.summary.range.from.balance;
            }
        }
    }
    // Expands known upload ranges across a required window by inserting synthetic missing/fake gaps.
    calcExpandedRange = (startDate, endDate) => {

        const uploadsRanges = this.uploadsRanges || [];
        //   if (this.mortgage.requirement.statementAlignmentDate) {
        uploadsRanges.forEach(range => {
            if (range.balanceOnDate) {
                range.balanceOnRangeStart = range.balanceOnDate(startDate)
                range.balanceOnRangeEnd = range.balanceOnDate(endDate)
            }
        })
        //   }


        // Normalizes ranges, removes fully-contained overlaps, and inserts missing intervals.
        const fillGaps = (ranges, startDate, endDate) => {
            // input looks like this:
            // start: {
            //     date: lastEndDate.add(1, 'day'),
            // },
            // end: {
            //     date: endDate,
            // }
            // clear out ranges that are included in other (larger) ranges
            const result = [];

            const input = ranges.filter(r => r.start && r.end).map(r => {
                const start = r.start.date
                const end = r.end.date

                const normalizedStart = start.isBefore(end) ? start : end
                const normalizedEnd = start.isAfter(end) ? start : end
                // const clippedStart = normalizedStart.isBefore(startDate)
                //     ? startDate
                //     : normalizedStart
                //
                // const clippedEnd = normalizedEnd.isAfter(endDate)
                //     ? endDate
                //     : normalizedEnd
                //
                // // completely outside requested range
                // if (
                //     clippedEnd.isBefore(startDate) ||
                //     clippedStart.isAfter(endDate)
                // ) {
                //     return null
                // }
                return {
                    original: r,
                    start: normalizedStart,
                    end: normalizedEnd
                }
            })


            const filtered = input.filter((rangeA, i) => {
                if (!rangeA) return false
                return !input.some((rangeB, j) => {
                    if (i === j) return false // don't compare with self
                    return (
                        rangeA.start.isSameOrAfter(rangeB.start) &&
                        rangeA.end.isSameOrBefore(rangeB.end)
                    )
                })
            })

            if (!filtered.length) {

                return [{
                    missing: true,
                    start: {
                        date: startDate,
                    },
                    end: {
                        date: endDate,
                    }
                }]
            }

            const betterRanges = filtered.map(r => r.original).sort((a, b) => {
                if (a.start.date.isBefore(b.start.date)) {
                    return -1;
                } else if (a.start.date.isAfter(b.start.date)) {
                    return 1;
                }
                return 0
            })


            // now fill in gaps
            for (let i = 0; i < betterRanges.length; i++) {
                const current = betterRanges[i];
                const prev = betterRanges[i - 1];

                // if the start date of the first is after the required start date, insert a gap at the beginning
                if (!prev && current.start.date.isAfter(startDate)) {
                    // If first item, insert missing range before it if it's not a newly opened account

                    if (!this.data?.isNewAccount) {

                        result.push({
                            missing: true,
                            start: {
                                date: startDate,
                            },
                            end: {
                                date: current.start.date,
                            }
                        });
                    } else {

                        result.push({
                            fake: true,
                            start: {
                                date: startDate,
                            },
                            end: {
                                date: current.start.date,
                            }
                        });
                    }
                }

                // Compare with previous
                if (prev) {
                    const prevEnd = prev.end.date;
                    const currStart = current.start.date;
                    if (prevEnd.isAfter(currStart)) {

                        //throw new Error('Overlapping dates detected between items: ' + JSON.stringify({prev, current}));
                        console.log(`Overlapping dates detected between ${this.personalTitle} items: `);

                    }
                    const dayGap = currStart.diff(prevEnd, 'day');

                    const balanceGap = 0 // Math.abs(prev.end.balance - current.start.balance);

                    if (dayGap > 1 || balanceGap > 1.0) {

                        result.push({
                            missing: true,
                            start: {
                                date: prev.end.date,
                            },
                            end: {
                                date: current.start.date,
                            }
                        });
                    }
                }
                // Add actual item
                result.push(current);
            }

            // Check final gap
            const last = result[result.length - 1];
            const lastEndDate = last?.end?.date

            if (lastEndDate && lastEndDate.isBefore(endDate)) {

                if (!this?.data?.isClosed) {

                    // check if the lastEndDate is before the startDate to get the correct start date for the gap
                    const realEndDate = lastEndDate.isBefore(startDate) ? startDate : lastEndDate
                    result.push({
                        missing: true,
                        start: {
                            date: realEndDate,
                        },
                        end: {
                            date: endDate,
                        }
                    });
                } else {

                    result.push({
                        fake: true,
                        start: {
                            date: lastEndDate,
                        },
                        end: {
                            date: endDate,
                        }
                    });
                }
            }

            return result;
        }

        return fillGaps(this.uploadsRanges, startDate, endDate)

    }
    // Returns the canonical bundle filename for this section.
    getBundleFileName = () => {
        return getBundleSectionFileName(this)
        let fileName = ''
        if (!!this.applicant) {
            fileName += this.mortgage[`applicant${this.applicant}`].firstName
            fileName += '-'
        }
        fileName += this.props.title.replace(/\s/g, '-')
        fileName += '.pdf'
        fileName = fileName.toLowerCase()
        return fileName
    }

    // Sorts uploads by a date-like value (active first), then refreshes office helpers and computed validity range.
    sortByDateProp(dateProperty) {
        this.sortDateProp = dateProperty || null;
        if (dateProperty) {
            this.uploads.sort((a, b) => {
                if (!a.isActive) {
                    return 1
                }
                if (!b.isActive) {
                    return -1
                }
                if (!a?.values[dateProperty]) { // no dates to go top
                    return -1
                }
                if (!b?.values[dateProperty]) {
                    return 1
                }
                if (dateProperty === 'year') {
                    // If sorting by year, compare the year part of the date
                    const yearA = new Date(a.values[dateProperty], 0, 1); // January 1st of the year
                    const yearB = new Date(b.values[dateProperty], 0, 1);
                    return yearB - yearA; // Sort by year descending
                }
                if (a?.values[dateProperty]?.isSame(b?.values[dateProperty])) {
                    return 0; // If dates are the same, keep original order
                }
                return a.values[dateProperty].isBefore(b.values[dateProperty]) ? 1 : -1;
            })
        }
        this.uploadsOffice = new sectionUploadsOffice(this)
        this.validityRange = this.uploadsOffice.getRange()
    }

    _sortVerifiableUploads(dateProperty) {
        if (!dateProperty) {
            throw new Error('dateProperty is required for _sortVerifiableUploads')
        }

        return [...this.verifiableUploads].sort((a, b) => {
            if (!a.isActive) {
                return 1
            }
            if (!b.isActive) {
                return -1
            }
            if (!a?.values[dateProperty]) { // no dates to go top
                return -1
            }
            if (!b?.values[dateProperty]) {
                return 1
            }
            if (dateProperty === 'year') {
                // If sorting by year, compare the year part of the date
                const yearA = new Date(a.values[dateProperty], 0, 1); // January 1st of the year
                const yearB = new Date(b.values[dateProperty], 0, 1);
                return yearB - yearA; // Sort by year descending
            }
            if (a?.values[dateProperty]?.isSame(b?.values[dateProperty])) {
                return 0; // If dates are the same, keep original order
            }
            return a.values[dateProperty].isBefore(b.values[dateProperty]) ? 1 : -1;
        })
    }

// Adds baseline upload problems for sections that are not evaluated via verifiable-upload rules.
    setUnverifiableProblems = () => {
        this.problems.push(...this.#makeArray(this.problemsList.universalUploadProblems()))
    }

// Explains why there are no active verifiable uploads, based on the most recent inactive upload.
    mostRecentInactiveReason = () => {
        const activeUploads = this.uploads.filter(u => u.isActive && u.isVerifiable)
        if (!activeUploads.length && this.uploads.length) {
            // find the reason why there's no active upload
            const oldUploads = this.uploads.filter(u => !u.isActive).sort((a, b) => new Date(b.props.upload.createdAt) - new Date(a.props.upload.createdAt))
            if (oldUploads.length) {
                const mostRecentOld = oldUploads[0]
                if (!mostRecentOld.isVerifiable) {
                    return `Last upload is not the right type`
                }
                if (mostRecentOld.isExpired) {
                    if (['bank-statements', 'updated-statements'].includes(this.category) && this.statementAlignmentDate) {
                        const start = this.statementAlignmentDate.add(1, 'day').subtract(6, 'months')
                        const end = this.statementAlignmentDate
                        return 'Minimum required range is ' + joinWithConjunction([start.format('D MMM YYYY'), end.format('D MMM YYYY')], ' to ')
                    }
                    if (this.name.startsWith('payslips')) {
                        return 'All payslips from the last 3 months are required'
                    }


                    return `Last upload is too old`
                } else if (mostRecentOld.isRejected) {
                    return `Last upload has been returned`
                }
            }
        }
        return null
    }
// Problem factories that evaluate raw section/upload conditions and return `problem` instances.
    rawProblems = {
        // Flags sections with no uploads at all (plus bundle impact), optionally including aligned statement range guidance.
        noUploads: () => {
            if (!this.uploads.length && !this.data?.updateAtPreApproval) {
                const text = this.statementAlignmentDate && this.props.isStatement ? (() => {
                    const startDate = this.statementAlignmentDate.add(1, 'day').subtract(6, 'months')
                    const endDate = this.statementAlignmentDate
                    return `(Min Period: ${startDate.format('D MMM YYYY')} to ${endDate.format('D MMM YYYY')} )`
                })() : ''
                return [new problem({
                    type: 'USER',
                    enum: 'NOT_STARTED',
                    title: `No Uploads${text}`,
                    reason: 'No uploads available',
                    message: `Uploads not started`,
                    userMessage: `Not started`,
                }),
                    new problem({
                        type: 'BUNDLE',
                        title: 'No Uploads',
                        message: `No active uploads`,
                    })]
            }
        },
        // Flags sections where uploads exist but none are currently active and verifiable.
        noActiveUploads: () => {
            const problems = []
            const activeUploads = this.uploads.filter(u => u.isActive && u.isVerifiable)
            if (!activeUploads.length && !this.data?.updateAtPreApproval) {
                const reason = this.mostRecentInactiveReason()
                problems.push(new problem({
                    type: 'USER_ALERT',
                    enum: 'NO_ACTIVE_UPLOADS',
                    body: 'Another Upload Needed',
                    title: `No valid uploads - ${reason}`,
                }))
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'No Valid Uploads',
                    message: `No valid uploads`,
                }))
                return problems
            }
            return null

        },
        // Flags active verifiable uploads that are missing required extracted/answered data fields.
        missingData: () => {
            const missingDataUploads = this.uploads.filter(u => u.isActive && u.isVerifiable && !u.allValuesAnswered)
            if (missingDataUploads.length) {
                return new problem({
                    type: 'DATA',
                    title: 'Missing Upload Data',
                    message: `Uploads missing data`,
                    uploadIDs: missingDataUploads.map(u => u.id)
                })
            }
        },
        // Flags unanswered user-facing and lender-facing queries that block completion/bundling.
        queriesUnanswered: () => {
            const problems = []
            const unansweredByUser = this.uploads.filter(q => q.isActive && q.missingUserAnswers)
            const unansweredForCoverNote = this.uploads.filter(q => q.isActive && q.missingLenderAnswers && (q.private || q.userAnswered))
            if (unansweredByUser.length) {
                problems.push(new problem({
                    type: 'USER_QUERIES',
                    enum: 'QUERIES_NOT_ANSWERED',
                    title: 'We have a query - check the app',
                    message: `User Query Not Answered`,
                    queryIDs: unansweredByUser.map(q => q.id),
                }))
            }
            if (unansweredForCoverNote.length) {
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Unanswered Queries for Cover Note',
                    message: `Missing Cover Note Answer for Query`,
                    queryIDs: unansweredForCoverNote.map(q => q.id),
                }))
            }
            return problems.length ? problems : null
        },
        // Flags active verifiable uploads that are not PDF and have not been converted.
        nonPdfUploads: () => {
            const nonPdfUploads = this.uploads.filter(u => u.isActive && u.isVerifiable && u.props.upload.contentType !== 'application/pdf' && !u.props.upload.pdffed)
            if (nonPdfUploads.length > 0) {
                return new problem({
                    type: 'BUNDLE',
                    title: 'Non-PDF Upload',
                    message: 'Non-PDF upload - convert to PDF',
                    uploadIDs: nonPdfUploads.map(u => u.id)
                })
            }
        },
        // Flags manual (non-system) section alerts so automations do not overwrite them.
        manuallyCreatedAlertsActive: () => {
            const alertAuthor = this?.progress?.alertAuthor
            const alertBody = this?.progress?.alertBody
            if (alertBody && alertAuthor !== 'system') {
                return new problem({
                    type: 'BUNDLE',
                    name: 'MANUAL_MORE_ALERT_ACTIVE',
                    //title: 'Manually Created More Requested Active',
                    message: `Manually created alerts on active uploads`,
                    uploadIDs: this.uploads.map(u => u.id),
                    title: `${alertBody.join('\n')}`,
                    body: 'Another upload needed'
                })
            }
        },
        // Flags sections exceeding the allowed number of active verifiable uploads.
        tooManyUploads: (n) => {
            if (this.uploads.filter(u => u.isActive && u.isVerifiable).length > n) {
                return new problem({
                    type: 'BUNDLE',
                    title: 'Too Many Uploads',
                    reason: `Too many uploads for this bundle`,
                    message: `Mark supplementary uploads as not verifiable or remove them. Only ${n} is allowed for this section.`,
                })
            }
        },
    }
// Normalizes helper return values into an array so callers can compose problem pipelines safely.
    #makeArray = (value) => {
        if (Array.isArray(value)) {
            return value;
        } else if (value) {
            return [value];
        } else {
            return [];
        }
    }
// Composed problem pipelines used by different section rule sets.
    problemsList = {

        // Baseline checks that apply to all upload sections.
        universalUploadProblems: () => {
            const prob = this.rawProblems.noUploads() ?? this.rawProblems.noActiveUploads() ?? this.rawProblems.nonPdfUploads() ?? this.rawProblems.manuallyCreatedAlertsActive()

            const probs = this.#makeArray(prob)
            probs.push(...this.rawProblems.queriesUnanswered() || [])

            if (!probs.length) {
                return null
            }
            return probs
        },
        // Baseline checks plus verifiable-upload checks (active uploads and missing data).
        universalVerifiedUploadProblems: () => {
            const prob = this.problemsList.universalUploadProblems() ?? this.rawProblems.noActiveUploads() ?? this.rawProblems.missingData()


            return this.#makeArray(prob)
        },
        // Single-upload sections: verified checks plus max-upload-count enforcement.
        singleUploadUserProblems: () => {
            const prob = this.problemsList.universalVerifiedUploadProblems() ?? this.rawProblems.tooManyUploads(1)
            return this.#makeArray(prob)
        },
        // Ensures the summarized range meets minimum duration requirements.
        summaryRangeTooShort: (n, units) => { // always 6 months + 1 day
            const problems = []

            if (!this?.summary?.range?.to?.date || !this?.summary?.range?.from?.date) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'No date set',
                    message: 'Range missing',
                }))

            }
            if (this?.summary?.range?.ok) {


                const diffInRange = Number((this.summary.range.to.date.endOf("day")?.diff(this.summary.range.from.date.startOf("day"), units, true) || 0).toFixed(1));

                if (diffInRange < n && !this.data?.isClosed && !this.data?.isNewAccount) {
                    problems.push(new problem({
                        type: "BUNDLE",
                        title: 'Range Too Short',
                        message: `Range required ${n} ${units}, have ${diffInRange}`,
                    }))
                }
            }
            return problems
        },
        //http://localhost:8000/mortgage/b609cfa9-d707-4fc2-9b4e-d97c833996d3/new-client-view <<< Payslips shouldn't be asked for

        //http://localhost:8000/mortgage/b609cfa9-d707-4fc2-9b4e-d97c833996d3/dashboard/APPROVAL <<< Evidence of details for new account


        // Converts missing expanded date segments into user alerts with bank-specific messaging.
        missingInExpandedRange: (expandedRange) => {

            const missing = expandedRange.filter(range => range.missing)


            return missing.map(range => {

                if (range.start.date.format("DD-MM-YYYY") === range.end.date.format("DD-MM-YYYY")) {
                    return new problem({
                        type: 'BUNDLE',
                        title: 'Closing balance does not carry forward',
                        message: `Closing balance does not carry forward`,
                    })
                }
                let isRevolut = !this.name.startsWith('debts') && ((this?.data?.accountNumber || this?.data?.iban || '').replace(/\s+/g, '').toUpperCase().startsWith('IE87REVO') || this.title.toLowerCase().includes('revolut'))
                if (isRevolut && this.statementAlignmentDate && !this.data?.updateAtPreApproval) {
                    const alignedEnd = this.statementAlignmentDate.endOf('day')
                    const alignedStart = this.statementAlignmentDate.add(1, 'day').subtract(6, 'months').startOf('day')
                    return new problem({
                        type: 'USER_ALERT',
                        enum: 'INCOMPLETE_RANGE',
                        title: `Missing ${alignedStart.format('D MMM')} - ${alignedEnd.format('D MMM')}`,
                        body: `Upload a new statement for the full range ${alignedStart.format('D MMM YYYY')} - ${alignedEnd.format('D MMM YYYY')}`,
                    })
                }
                return new problem({
                    type: 'USER_ALERT',
                    enum: 'INCOMPLETE_RANGE',
                    title: `Missing ${range.start.date.format('D MMM')} - ${range.end.date.format('D MMM')}`,
                    body: `Upload the statements for the missing range`,
                })
            })
        }


    }
// Placeholder for section-specific automation checks tied to single-upload expiry behavior.
    automations = {
        // Evaluates whether the single qualifying upload should be expired (currently no-op).
        singleUploadShouldExpire: () => {
            const activeUpload = this.uploads.filter(u => u.isActive && u.isVerifiable && u.allValuesAnswered)[0];
            if (activeUpload) {

            }
        }
    }
// Builds system automation updates (expire uploads, sync logical names, complete/incomplete state, alerts, requirement flags).
    getAutomations = () => {

        if (this.props.custom) {
            this.setUnverifiableProblems()
        }
        let limitDate = this.useStatementAlignmentDateToExpire ? this.statementAlignmentDate || dayjs() : dayjs()
        const automations = [];

        // remove alert if actioned by user and there is pending uploads

        if (this.progress?.alertDismissed && this.progress.alertBody && !this.activeUploads.find(u => u.props.upload.status === UploadStatuses.PENDING)) {
            automations.push({
                message: `Section should remove more requested: ${this.progress.alertTitle}`,
                update: {
                    target: `progress[${this.progress.id}]`,
                    pairs: {
                        alertAuthor: null,
                        alertBody: null,
                        alertDismissed: null,
                        alertTitle: null,
                    }
                }
            });
        }


        // Check for expired Uploads
        this.uploads.filter(u => u.isActive && u.isVerifiable).forEach(u => {
            if (u.dateData?.expires && u.dateData.expires.isBefore(limitDate)) {
                let label = u.dateData.range?.ok ? `${u.dateData.range.from.date.format('D MMM')} - ${u.dateData.range.to.date.format('D MMM')}` : 'No Range'

                automations.push({
                    title: `Upload ${label} has expired`,
                    message: `Upload ${label} has expired`,
                    update: {
                        target: `uploads[${u.id}]`,
                        pairs: {
                            statusOn: new Date().toISOString(),
                            statusBy: 'system',
                            status: 'EXPIRED',
                        }
                    },
                    uploadID: u.id,
                });

            }
            if (automations?.length) {
                console.log({automations});
            }
            // set the logical name of file
            if (u.dateData?.range?.ok) {
                const textRange = `${u.dateData.range.from.date.format('D MMM YYYY')} - ${u.dateData.range.to.date.format('D MMM YYYY')}`
                if (u.props.upload.logicalName !== textRange) {

                    automations.push({
                        title: 'Setting logical name',
                        message: `Setting logical name to ${textRange}`,
                        update: {
                            target: `uploads[${u.id}]`,
                            pairs: {
                                logicalName: textRange,
                            }
                        },
                        uploadID: u.id,
                    })
                }
            }
        });

        // mark user complete if no user upload-steps
        const userProblems = this.problems.filter(p => p.type === 'USER')
        const userAlertProblems = this.problems.filter(p => p.type === 'USER_ALERT')

        const dataProblems = this.problems.filter(p => p.type === 'DATA')
        const userQueryProblems = this.problems.filter(p => p.type === 'USER_QUERIES')
        const userManualAlertProblems = this.problems.filter(p => p.name === 'MANUAL_MORE_ALERT_ACTIVE')

        if (!this.props.custom && this.uploads.length && !userQueryProblems.length && !userManualAlertProblems.length && !userProblems.length && !userAlertProblems.length && !dataProblems.length && this.progress && (!this.progress.sectionUserComplete || !this.progress.sectionChecked)) {

            automations.push({
                message: `Section (${this.personalTitle}) should be marked as complete`,
                update: {
                    target: `progress[${this.progress.id}]`,
                    pairs: {
                        sectionUserComplete: 1,
                        sectionChecked: new Date().toISOString(),
                        sectionCheckedBy: 'system',
                    }
                }
            });

        }

        if (!this.uploads.length || userQueryProblems.length || userProblems.length || userAlertProblems.length || dataProblems.length || userManualAlertProblems.length) {
            if (this.progress && (this.progress?.sectionUserComplete || this.progress?.sectionChecked)) {
                automations.push({
                    message: `Section should be marked as incomplete`,
                    update: {
                        target: `progress[${this.progress.id}]`,
                        pairs: {
                            sectionUserComplete: 0,
                            sectionChecked: null,
                            sectionCheckedBy: 'null',
                        }
                    }
                });
            }
        }
        if (userAlertProblems.length) {
            // don't overwrite a manually created alert!
            if (this.progress && (!this.progress.alertAuthor || this.progress.alertAuthor === 'system')) {

                const title = joinWithConjunction(userAlertProblems.map(m => m.title), 'and')
                if (this.progress?.alertTitle !== title) {
                    automations.push({
                        message: `Section should have request more: ${userAlertProblems[0].title}`,
                        update: {
                            target: `progress[${this.progress.id}]`,
                            pairs: {
                                alertAuthor: 'system',
                                alertBody: [userAlertProblems[0].body],
                                alertDismissed: false,
                                alertTitle: title,
                            }
                        }
                    });
                }
            }
        } else {
            // don't clear a manually created alert!
            if (this.uploadsOffice.hasMoreUploadsRequestedBySystem) {
                automations.push({
                    message: `Section should clear More Requested Alert`,
                    update: {
                        target: `progress[${this.progress.id}]`,
                        pairs: {
                            alertAuthor: null,
                            alertBody: null,
                            alertDismissed: false,
                            alertTitle: null,
                        }
                    }
                });
            }
        }

        // if there's a shortfall in own MPI, add that letter required in the requirements
        if (dataProblems.find(p => p.title === 'Insufficient Policy Term')) {
            console.log('AUTOMATION!')
            if (![true, false].includes(this.mortgage.requirement.mpiShortfallLetterRequired)) {
                automations.push({
                    message: `Setting mpiShortfallLetterRequired to true on requirement`,
                    update: {
                        target: `requirement`,
                        pairs: {
                            mpiShortfallLetterRequired: true,
                        }
                    }
                });
            }
        }
        // if (this.progress && !this.progress.userStages){
        //     automations.push({
        //         message: `Setting default user stages to all stages`,
        //         update: {
        //             target: `progress[${this.progress.id}].userStages`,
        //             value: [this.stage],
        //         }
        //     });
        // }
        return automations
    }
// Replaces current problems list, enforcing array input for downstream consumers.
    setProblems = (array) => {
        if (!Array.isArray(array)) {
            throw new Error(`setProblems expects an array, got ${typeof array}`)
        }
        this.problems = array;
    }
}